import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "upload",
  "use": "upload-usage",
  "viewBox": "0 0 1103 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1103 1024\" id=\"upload\">\n<path d=\"M964.923 689.231v137.846h-827.077v-137.846h-137.846v275.692h1102.769v-275.692h-137.846zM275.692 413.538h206.769v344.615h137.846v-344.615h206.769l-275.692-413.538-275.692 413.538z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol